import { schema } from 'normalizr';

const likeSchema = new schema.Entity('likes', {});

export default likeSchema;
